import { inject, Injectable, signal, Signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService, Result } from '@softline/core';
import { Belegart } from '@softapps/wws/gesamtabfrage/api';
import { BelegartRepository } from '../repositories/belegart.repository';

@Injectable()
export class BelegartService extends ReadonlyRepositoryCollectionService<Belegart, Result<Belegart[]>, undefined> {

  override params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(BelegartRepository));
  }

  protected override getAll(result: Result<Belegart[]> | null | undefined): Belegart[] {
    return result?.result ?? [];
  }
}
